import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import OCSubBar from '../components/liveoc/OCSubBar';
import OCTables from '../components/liveoc/OCTables';
import OCCharts from '../components/liveoc/OCCharts';
import ResSupTable from '../components/liveoc/ResSupTable';
import '../styles/live-oc.css';

export default function LiveOCPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [symbol, setSymbol] = useState(searchParams.get('symbol') || 'NIFTY');
  const [date, setDate] = useState(searchParams.get('date') || '');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async (sym, dt) => {
    setLoading(true);
    setError(null);
    try {
      let url = `/api/api_live_oc.php?symbol=${encodeURIComponent(sym)}`;
      if (dt) url += `&date=${encodeURIComponent(dt)}`;
      const res = await fetch(url, { credentials: 'include' });
      const json = await res.json();
      if (!res.ok) throw new Error(json.error || `HTTP ${res.status}`);
      setData(json);
      if (!dt && json.selectedDate) setDate(json.selectedDate);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData(symbol, date || null);
  }, [symbol, date, fetchData]);

  useEffect(() => {
    const t = setInterval(() => fetchData(symbol, date || null), 300000);
    return () => clearInterval(t);
  }, [symbol, date, fetchData]);

  useEffect(() => {
    document.querySelector('.tmr-main')?.classList.add('oc-pg');
    return () => document.querySelector('.tmr-main')?.classList.remove('oc-pg');
  }, []);

  const onSymbolChange = (sym) => {
    setSymbol(sym);
    setSearchParams(prev => {
      const p = new URLSearchParams(prev);
      p.set('symbol', sym);
      return p;
    });
  };

  const onDateChange = (dt) => {
    setDate(dt);
    setSearchParams(prev => {
      const p = new URLSearchParams(prev);
      p.set('date', dt);
      return p;
    });
  };

  if (loading && !data) {
    return <div className="p-4 text-sm text-[var(--text-muted)]">Loading live option chain…</div>;
  }

  if (error && !data) {
    return <div className="p-4 text-sm text-red-400">Error: {error}</div>;
  }

  return (
    <div className="oc-page flex flex-col h-full min-h-0">
      <OCSubBar data={data} symbol={symbol} onSymbolChange={onSymbolChange} onDateChange={onDateChange} />
      <div className="oc-g" id="ocGrid">
        <OCTables ceRows={data?.ceRows || []} peRows={data?.peRows || []} />
        <OCCharts series={data?.series} symbol={symbol} ohlcDebug={data?.ohlcDebug} />
        <ResSupTable rows={data?.series?.spotWL || []} />
      </div>
    </div>
  );
}